import React from 'react';
import { Footer } from '../Common/Footer';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { Link } from 'react-router-dom';
import FollowFavourites from '../../Models/FollowFavourites';
import { Header } from '../Common';
class FollowersBuyer extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert('ログインしてください')
            window.location.href = '/login';
        };
        this.state = {
            _id: false,
            followings: [],
            logged_user_id: '',
            followingsMessage: '',
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state.logged_user_id = logged_user.id;
        this.getMyFollowings();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getMyFollowings() {
        FollowFavourites.getFollowings(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ followings: res.data.payload })
            } else {
                this.setState({ followingsMessage: res.data.message })
            }
            console.log(this.state.followings)
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <BuyerSidebar />
                            </div> */}

                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%" ,fontSize:'20px'}}>
                                    フォロー
                                </div>
                                {(() => {
                                    if (this.state.followings.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                {this.state.followings.map(group =>
                                                    <div className="service-list-divs" style={{ textAlign: "left" }}>
                                                        <div className="" style={{ padding: "4%" }}>
                                                            <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={group.img} height="50" width='50' />&nbsp;&nbsp;
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                state: { id: group.seller_id }
                                                            }} className="sky-a ml-3">{group.first_name}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for Desktop View
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>

                                    <div className="col-md-8">
                                        <div className="mb-1input_name big_font text-left" style={{ width: "100%" }}>
                                            フォロー
                                    </div>
                                        {(() => {
                                            if (this.state.followings.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                        {this.state.followings.map(group =>
                                                            <div className="service-list-divs" style={{ textAlign: "left" }}>
                                                                <div className="" style={{ padding: "4%" }}>
                                                                    <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={group.img} height="50" width='50' />&nbsp;&nbsp;
                                                                <Link to={{
                                                                        pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                        state: { id: group.seller_id }
                                                                    }} className="sky-a ml-3">{group.first_name}
                                                                    </Link>
                                                                </div>
                                                                {/* {/ <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> /} */}
                                                                {/* <div className="col-md-2" style={{ textAlign: "left" }}>
                                                                    <img alt="" className="rounded-circle" src={group.img} height="50" width="50" />&nbsp;
                                                                </div>
                                                                <div className="col-md-10" style={{ textAlign: "left" }}>
                                                                    <Link to={{
                                                                        pathname:'/my-profile-view',
                                                                        state: { id: group.seller_id}
                                                                        }}style={{ color: "#04affd", fontSize: "14px" }}>
                                                                        <span>{group.first_name}</span>
                                                                        </Link> */}
                                                                {/* <div style={{ fontSize: "14px" }}><span><b>{group.total} 人のフォロワーがいます。</b></span></div> */}
                                                                {/* </div> */}
                                                                {/* </div> */}
                                                                {/* <div className="col-md-11 m-3 row" style={{ border: "1px solid #ece9e9", borderRadius: "4px", maxHeight: "145px" }}>
                                                                <div style={{ color: "#fca000", fontSize: "15px", fontWeight: "700" }}>いま買える人気サービス！</div>
                                                                <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "14px", textDecoration: "underline" }}>{group.trimed_long_desc}...</div>
                                                            </div> */}
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { FollowersBuyer }